export default "__VITE_ASSET__ca76d8ff__"